export default {"src":"/_next/static/media/tiktok.cf25a8e6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};